export default theme => ({
  preview_image: {
    width: "100%",
    height: "auto",
  },
  selector__clickable: {
    cursor: "pointer !important",
  },
  fullWidth: {
    width: "100%",
  }
});
